module.exports = __webpack_public_path__ + "img/zuankong.prt.4041d88f.jpg";